import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { ApplicationStep } from "../nuvei-application-step";
import { DOCUMENT } from "@angular/common";
import { NgControl } from "@angular/forms";

export const sqFootageDisplayValues: { [value: string]: string } = {
  '0_250': '0 - 250 ft.',
  '251_500': '251 - 500 ft.',
  '501_2000': '501 - 2000 ft.',
  '2001': 'More than 2000 ft.'
};

@Component({
  selector: 'app-nuvei-application-additional',
  templateUrl: './nuvei-application-additional.component.html',
  styleUrls: ['./nuvei-application-additional.component.scss']
})
export class NuveiApplicationAdditionalComponent extends ApplicationStep<'additionalBusinessInfoForm'> {

  sqFootageDisplayValues = sqFootageDisplayValues;

  @ViewChild('squareFootageInput') squareFootageInput!: ElementRef<HTMLInputElement>;
  @ViewChild('squareFootageInput', {read: NgControl})
  squareFootageInputDirective!: NgControl;

  fieldExplanations = [
    { id: 'website', title: 'Business Website (Optional)', explanation: 'Your company’s official website.\nEnsure it is active and represents your business accurately.' },
    { id: 'businessType', title: 'Business type', explanation: 'The category of services or work your business provides (e.g., roofing, plumbing, remodeling).' },
    { id: 'description', title: 'Business Description', explanation: 'A detailed explanation of your business, including the scope of services, specialties, or any relevant details customers should know.' },
    { id: 'zoning', title: 'Zoning', explanation: 'The type of area where your business headquarters are located and legally permitted to operate.\nCheck property records or lease agreements.' },
    { id: 'locale', title: 'Locale', explanation: 'The specific setting of your business within the zoned area.' },
    { id: 'squareFootage', title: 'Square footage of location', explanation: 'The size of your business location.\nMeasure or check lease/property documents.' },
    { id: 'refundPolicy', title: 'Refund Policy', explanation: 'Your business’s policy on handling customer refunds, including eligibility, timeframes, and conditions.' },
  ];

  sqFootageKeys = [ '0_250', '251_500', '501_2000', '2001' ];


  constructor(
      @Inject(DOCUMENT) protected document: Document
  ) {
    super();
  }

  async ngAfterViewInit(): Promise<void> {
    super.ngAfterViewInit();
    if(this.squareFootageInputDirective) {
      this.sqFootageSelected(this.form.controls.squareFootage.value);
    }
  }

  sqFootageSelected(value: string) {
    const displayValue = sqFootageDisplayValues[value];
    this.squareFootageInputDirective.valueAccessor?.writeValue(displayValue);
  }
}
